import { useContext, useEffect } from "react";
import { AuthContext } from "../../SessionChecker/SessionChecker";
import { requestToExtractProducts } from "./RequestToExtractProduct";
import { useTranslation } from "react-i18next";
import "../../../css/Search/Explorer.css";
import { useNavigate } from "react-router-dom";

function Explorer() {
  const { productsDataInExplorer, setProductsDataInExplorer } =
    useContext(AuthContext);

  useEffect(() => {
    requestToExtractProducts(setProductsDataInExplorer);
  }, []);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="explorerMainDiv">
      <div className="productsDiv">
        {productsDataInExplorer.length === 0 ? (
          <div className="emptyDiv">
            <img src="/images/empty512.png"></img>
            <div className="emptyTitleDiv">{t("Empty")}</div>
          </div>
        ) : (
          productsDataInExplorer.map((product) => {
            const images = product.images || [];

            return (
              <div
                className="productPreviewDiv"
                key={product.id}
                onClick={() => {
                  navigate("/p/" + product.link);
                }}
              >
                <div className="productPreviewUserDiv">
                  {product.user[0].profile_image_url !== null ? (
                    <img src={product.user[0].profile_image_url}></img>
                  ) : (
                    <div className="profileImageDivInProductDiv"></div>
                  )}

                  <div>{product.user[0].username}</div>

                  {product.user[0].tick && (
                    <div className="tickDivInProductDiv">
                      <img src="/icons/green_tick.png"></img>
                    </div>
                  )}
                </div>

                <div className="productDataDiv">
                  <div className="productImageSlider">
                    {images.length > 0 ? (
                      images.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={`${product.name} ${index + 1}`}
                          className="productImage"
                          loading="lazy"
                          decoding="async"
                        />
                      ))
                    ) : (
                      <div className="productNoImage">{t("No Image")}</div>
                    )}
                  </div>
                  <div className="productInfoDivInProductPreview">
                    <div>
                      {product.name?.length > 20
                        ? product.name.slice(0, 20) + "..."
                        : product.name}
                    </div>

                    <span>{product.category}</span>

                    <div className="productPrice">
                      {Number(product.price).toLocaleString()} t
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default Explorer;
